import * as React from 'react';
import { CaptionAccentTypography, Conflict, InfoOutline } from '@components/atoms';
import { cn } from '@utils';
import { IconTextLine } from '@components/molecules/icon-text-line/icon-text-line';
import { InlineNoticeVariantEnum } from './inline-notice.types';

interface Props {
	children: React.ReactNode;
	className?: string;
	iconClassName?: string;
	messageClassName?: string;
	variant: InlineNoticeVariantEnum;
	testId?: string;
}

const variantIconMap = {
	[InlineNoticeVariantEnum.info]: InfoOutline,
	[InlineNoticeVariantEnum.warning]: InfoOutline,
	[InlineNoticeVariantEnum.error]: Conflict,
};

const variantColorMap = {
	[InlineNoticeVariantEnum.info]: 'text-info',
	[InlineNoticeVariantEnum.warning]: 'text-warning',
	[InlineNoticeVariantEnum.error]: 'text-error',
};

export const InlineNotice: React.FC<Props> = ({
	children,
	className,
	iconClassName,
	variant,
	testId,
	messageClassName,
}) => {
	const Icon = variantIconMap[variant];
	const iconColorClass = variantColorMap[variant];

	return (
		<div data-testid="inline-notice">
			<IconTextLine className={className} icon={<Icon className={cn('size-5', iconColorClass, iconClassName)} />}>
				<CaptionAccentTypography
					className={cn('text-primary', messageClassName)}
					truncate={false}
					data-testid={`${testId}-notice-text`}
				>
					{children}
				</CaptionAccentTypography>
			</IconTextLine>
		</div>
	);
};
